module.exports = __webpack_public_path__ + "static/abe.3acb7ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/abe.png
// module id = ./src/media/abe.png
// module chunks = 9005229563256848000